const Radio = {
    baseStyle: {
        control: {
            _checked: {
                _hover: {
                    background: 'primary.500',
                    borderColor: 'black',
                },
                background: 'primary.500',
                borderColor: 'neutral.600',
                // The white tick on the brand primary.500 fill is ~2.3:1 and fails
                // 1.4.11; primaryContrast is the theme-computed accessible (black/white)
                // pairing for whatever brand colour the property sets. BENG-4171 #32.
                color: 'primaryContrast.500',
            },
            _hover: {
                borderColor: 'black',
            },
            alignItems: 'center',
            background: 'white',
            borderColor: 'neutral.600',
            borderRadius: 'var(--booking-engine-space-1)',
            borderWidth: '1px',
            display: 'inline-flex',
            height: 'var(--booking-engine-space-6)',
            width: 'var(--booking-engine-space-6)',
        },
        label: {
            color: 'black',
            fontSize: 'md',
            fontWeight: 400,
            lineHeight: 'var(--booking-engine-space-6)',
            marginInlineStart: 'var(--booking-engine-space-2)',
        },
    },
};
export default Radio;
